import React, { lazy } from "react";
import Loadable from "../components/Loadable";
// import { authRoles } from "../auth/authRoles";
import { routeCheck } from "app/data/roles";

const ServiceOrderList = Loadable(lazy(() => import('app/views/serviceOrder/ServiceOrderList')));
const ServiceOrderPrint = Loadable(lazy(() => import('app/views/serviceOrder/ServiceOrderPrint')));

const serviceOrdersPaths = routeCheck(
  [
    { path: "/serviceOrders", element: <ServiceOrderList /> },
    { path: "/serviceOrders/print/:id", element: <ServiceOrderPrint />}
  ],
  false
)

export default serviceOrdersPaths;